import { createSlice } from '@reduxjs/toolkit';
import { createFilterInitialState, filterReducers, FilterState } from 'common/utils/sliceUtils/filterSliceUtils';

type StateWithClaimRoleMembership = { claimRoleMembership: FilterState };

const claimRoleMembershipSlice = createSlice({
    name: 'claimRoleMembership',
    initialState: createFilterInitialState(),
    reducers: () => ({
        ...filterReducers
    })
});

// eslint-disable-next-line no-restricted-syntax
export default claimRoleMembershipSlice.reducer;
export const { addNewFilter, removeFilter, clearFilters } = claimRoleMembershipSlice.actions;
export const selectFilters = (state: StateWithClaimRoleMembership) => state.claimRoleMembership.filters;
